export default [
    {
        key: 'BudgetDistributeModal',
        getComponent: function () { return import('./BudgetDistributeModal'); },
        title: i18n.get('预算'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
